import { motion } from "framer-motion";
import { ShieldCheck, Building2, Smartphone } from "lucide-react";
import { siteContent } from "@/content/site";

const PARTNER_ICONS = {
  shield: ShieldCheck,
  building: Building2,
  phone: Smartphone,
};

const { partners } = siteContent;

export default function PartnerStrip() {
  const items = [...partners.items, ...partners.items];
  return (
    <section
      data-testid="partners-section"
      className="border-y border-[#C9DDD6] bg-[#E1EEEA]/50 py-5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-8">
        <span className="hidden md:inline-block shrink-0 text-xs font-bold uppercase tracking-[0.2em] text-[#6A8290]">
          {partners.eyebrow}
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex items-center gap-12 animate-marquee whitespace-nowrap">
            {items.map((p, i) => {
              const Icon = PARTNER_ICONS[p.iconKey] || ShieldCheck;
              return (
                <div key={i} className="flex items-center gap-3 shrink-0">
                  <div className="w-9 h-9 rounded-full bg-white border border-[#C9DDD6] flex items-center justify-center">
                    <Icon className="w-4 h-4 text-[#1F4E5F]" />
                  </div>
                  <div className="leading-tight">
                    <div className="text-sm font-semibold text-[#0E2A36]">
                      {p.label}
                    </div>
                    <div className="text-xs text-[#6A8290]">{p.sub}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
